import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import axios from "axios";
import { setBnText, setEnText, setEntity, setResult } from '../audio-recorder/asrSlice'
import Button from 'react-bootstrap/Button';
import { hideLoader, showLoader } from '../loader/loaderSlice';
import { Feedback } from '../feedback';

const AsrChat = () => {
    const dispatch = useDispatch();
    const bnUserInputText = useSelector((state) => state.asr.bnText);
    const enUserInputText = useSelector((state) => state.asr.enText);
    const userInputText = bnUserInputText === "" ? "" : "বাংলা: " + bnUserInputText + "\n\nEnglish: " + enUserInputText;

    const appToken = useSelector((state) => state.auth.appToken);

    const updateBnText = (input) => {
        dispatch(setBnText(input))
    }

    
    return (
        <div className='asr mini-card'>
            <h4>User Input</h4>
            <div>
                <textarea
                    value={userInputText}
                    rows="5" style={{"width": "100%"}}
                    readOnly />
            </div>           
            <div>                
                <Feedback 
                    type = {"asr"} />                
            </div>
        </div>
    );
};


export default AsrChat;